import React from 'react';
import Icon from "../../Atoms/Icon";
import PayrollHeaderWrapper from "../../Wrappers/PayrollHeaderWrapper";
import MonthYearPickerInput from "../../Molecules/Pickers/MonthYearPickerInput";

const PayrollHeader = () => {
  return (
    <PayrollHeaderWrapper className="date-picker">
      <label className="s-relative">
        <h1 className="t2 s-mb-0 s-cross-center s-cross-center nowrap hover-change cursor-pointer normal-radius s-px-8px s-py-4px">
          <Icon
            className="s-mr-8px"
            svg="calendar"/>
          <span className="s-mr-8px">Agosto del 2020</span>
          <Icon
            size="1rem"
            svg="down"/>
        </h1>
        <MonthYearPickerInput
          id="payroll-date"
        />
      </label>
      <button
        className="button"
        disabled>Cerrar mes
      </button>
    </PayrollHeaderWrapper>
  );
};

export default PayrollHeader;
